import { NgTemplateOutlet } from '@angular/common';
import { Component, contentChild, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-page-content',
  imports: [NgTemplateOutlet],
  templateUrl: './page-content.component.html',
  styleUrl: './page-content.component.scss',
})
export class PageContent {
  header = input<string>();
  subtitle = input<string>();
  subtitleTemplate = contentChild<TemplateRef<unknown>>('subtitle');
}
